import { render, staticRenderFns } from "./combien-de-temps-pour-creer-un-site-internet-vitrine.vue?vue&type=template&id=56df9060&"
import script from "./combien-de-temps-pour-creer-un-site-internet-vitrine.vue?vue&type=script&lang=js&"
export * from "./combien-de-temps-pour-creer-un-site-internet-vitrine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports